import pdfMake from 'pdfmake/build/pdfmake';
import { vfs } from 'pdfmake/build/vfs_fonts';
import dayjs from 'dayjs';

pdfMake.vfs = vfs;

const exportToPdf = (rows, columnsToExtract, title) => {
  // Create header objects directly from columnsToExtract
  const headers = columnsToExtract.map(column => ({
    text: column.headerName,
    style: 'header',
    alignment: 'center'
  }));

  // Create data rows using columnsToExtract
  const data = rows.map(row =>
    columnsToExtract.map(column => ({
      text: row[column.field]?.toString() || '',
      style: 'cell',
      margin: [0, 1]
    }))
  );

  const docDefinition = {
    pageOrientation: 'landscape',
    fonts: {
      Roboto: {
        normal: 'Roboto-Regular.ttf',
        bold: 'Roboto-Medium.ttf',
        italics: 'Roboto-Italic.ttf',
        bolditalics: 'Roboto-MediumItalic.ttf'
      }
    },
    header: {
      text: title,
      style: 'header',
      margin: [0, 5, 0, 0]
    },
    footer: (currentPage, pageCount) => ({
      columns: [
        {
          text: `Generated: ${dayjs().format('DD-MM-YYYY')}`,
          alignment: 'left',
          style: 'footer',
          margin: [5, 0, 0, 0]
        },
        {
          text: `Page ${currentPage} of ${pageCount}`,
          alignment: 'right',
          style: 'footer',
          margin: [0, 0, 5, 0]
        }
      ],
      margin: [5, 5, 5, 0]
    }),
    content: [
      {
        table: {
          headerRows: 1,
          widths: columnsToExtract.map(() => 'auto'),
          body: [headers, ...data],
        },
        layout: {
          fillColor: (rowIndex) => rowIndex === 0 ? '#f0f0f0' : null,
          hLineWidth: () => 0.7,
          vLineWidth: () => 0.7,
          hLineColor: () => '#444',
          vLineColor: () => '#444',
          paddingTop: () => 1,
          paddingBottom: () => 1,
          fit: columnsToExtract.map((_, index) => index),
          paddingLeft: () => 2,
          paddingRight: () => 2,
          defaultBorder: true
        }
      }
    ],
    styles: {
      header: {
        fontSize: 8,
        bold: true,
        alignment: 'center',
        font: 'Roboto',
        lineHeight: 1,
        border: [0.7, 0.7, 0.7, 0.7]
      },
      cell: {
        fontSize: 6.5,
        font: 'Roboto',
        lineHeight: 1,
        wordWrap: 'break-word',
        border: [0.5, 0.5, 0.5, 0.5]
      },
      footer: {
        fontSize: 7,
        color: '#666',
        font: 'Roboto'
      }
    },
    defaultStyle: {
      font: 'Roboto',
      fontSize: 6.5,
      lineHeight: 1
    },
    pageMargins: [10, 15, 10, 15],
    pageSize: 'A4',
    compress: true
  };

  pdfMake.createPdf(docDefinition, null, null, pdfMake.vfs).download(`${title}.pdf`);
};

export { exportToPdf };